import { VIEWS_MODULE_NAMESPACE } from '@/constants/modules';

import { router } from '../router';

export default async ({ flavor, domain, store }) => Promise.all([
  new Promise(async (resolve) => {
    const modules = await import(`../../src/domains/${domain}/store`)
      .then(result => result.default);
    store.registerModule(VIEWS_MODULE_NAMESPACE, modules);

    resolve({ store });
  }),
  new Promise(async (resolve) => {
    const style = await import(`./${flavor}/index.scss`);

    resolve({ style });
  }),
  new Promise(async (resolve) => {
    const domainRouter = await import(`../../src/domains/${domain}/router`);
    const domainRouterIntegrated = router(domainRouter.default);

    resolve({ router: domainRouterIntegrated });
  }),
]);
